import React from 'react';

const BadgeCard = ({ badge, achievement, locked = false }) => {
  const tierColors = {
    bronze: 'from-orange-400 to-orange-600',
    silver: 'from-gray-300 to-gray-500',
    gold: 'from-yellow-400 to-yellow-600',
    platinum: 'from-cyan-400 to-cyan-600'
  };

  const tierLabels = {
    bronze: 'Bronce',
    silver: 'Plata',
    gold: 'Oro',
    platinum: 'Platino'
  };

  return (
    <div className={`rounded-lg p-4 shadow-lg transition-all hover:scale-105 ${
      locked 
        ? 'bg-gray-800 opacity-60' 
        : `bg-gradient-to-br ${tierColors[badge.tier]}`
    }`}>
      <div className="text-center">
        <div className={`text-6xl mb-3 ${locked ? 'grayscale' : ''}`}>
          {locked ? '🔒' : badge.icon}
        </div>
        
        <h3 className={`text-lg font-bold mb-1 ${locked ? 'text-gray-400' : 'text-white'}`}>
          {badge.name}
        </h3>
        
        <span className={`text-xs px-2 py-1 rounded-full ${
          locked 
            ? 'bg-gray-700 text-gray-400' 
            : 'bg-white bg-opacity-30 text-white'
        }`}>
          {tierLabels[badge.tier]}
        </span>
        
        <p className={`text-sm mt-3 ${locked ? 'text-gray-400' : 'text-white opacity-90'}`}>
          {badge.description}
        </p>
        
        {achievement && achievement.earned_at && (
          <p className="text-xs mt-3 text-white opacity-75">
            Desbloqueado: {new Date(achievement.earned_at).toLocaleDateString('es-ES')}
          </p>
        )}
        
        {locked && achievement && achievement.progress > 0 && (
          <div className="mt-3">
            <div className="w-full bg-gray-700 rounded-full h-2">
              <div 
                className="bg-blue-500 h-2 rounded-full transition-all"
                style={{ width: `${Math.min((achievement.progress / badge.criteria.value) * 100, 100)}%` }}
              ></div>
            </div>
            <p className="text-xs text-gray-400 mt-1">
              {achievement.progress} / {badge.criteria.value}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BadgeCard;
